import { PricingInsightsResultDTO } from './CarrierPayDTO';
import { ShippingDetailsDTO } from './ShippingDetailsDTO';

export const PRICING_INSIGHTS_DEMO_SHIPPING_DETAILS: ShippingDetailsDTO = {
  origin: {
    city: 'Reno',
    state: 'NV',
    zip: '89506',
  },
  destination: {
    city: 'Reseda',
    state: 'CA',
    zip: '91335',
  },
  vehicles: [
    {
      $key: 'demo-vehicle-1',
      type: 'suv',
      year: 2020,
      make: 'Jeep',
      model: 'Grand Cherokee',
      is_inoperable: false,
    },
    {
      $key: 'demo-vehicle-12',
      type: 'sedan',
      year: 2021,
      make: 'Audi',
      model: 'A3',
      is_inoperable: false,
    },
  ],
};

export const PRICING_INSIGHTS_DEMO_DATA: PricingInsightsResultDTO = {
  carrier_pay: {
    distance: 835.25,
    confidence: 92,
    total_price: 840,
    price_per_km: 1.0068,
  },
  recent_moves: [
    {
      price: 800,
      price_per_mile: 1.54,
      price_per_vehicle: 400,
      price_per_mile_per_vehicle: 0.77,
      distance_miles: 519,
      dispatched_date: '2026-01-27',
      delivered_date: '2026-01-30',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2023,
          make: 'CAN-AM',
          model: 'MAVERICK X3 MAX X RS TURBO RR',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2024,
          make: 'MAZDA',
          model: 'CX-30 PREMIUM',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 800,
      price_per_mile: 1.54,
      price_per_vehicle: 400,
      price_per_mile_per_vehicle: 0.77,
      distance_miles: 519,
      dispatched_date: '2026-01-19',
      delivered_date: '2026-01-22',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2025,
          make: 'HYUNDAI',
          model: 'PALISADE CALLIGRAPHY',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2005,
          make: 'LEXUS',
          model: 'LS 430',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 1100,
      price_per_mile: 2.12,
      price_per_vehicle: 550,
      price_per_mile_per_vehicle: 1.06,
      distance_miles: 518,
      dispatched_date: '2026-01-09',
      delivered_date: '2026-01-16',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90249',
      },
      vehicles: [
        {
          type: 'suv',
          year: 2019,
          make: 'Mercedes-Benz',
          model: 'GLC',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2020,
          make: 'Kia',
          model: 'Optima',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 900,
      price_per_mile: 1.83,
      price_per_vehicle: 450,
      price_per_mile_per_vehicle: 0.91,
      distance_miles: 493,
      dispatched_date: '2025-11-26',
      delivered_date: '2025-11-29',
      origin: {
        city: 'Sparks',
        state: 'NV',
        zip: '89436',
      },
      destination: {
        city: 'Santa Clarita',
        state: 'CA',
        zip: '91354',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 1984,
          make: 'Nissan',
          model: '300 ZX',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'suv',
          year: 1987,
          make: 'jeep',
          model: 'Wrangler',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 900,
      price_per_mile: 1.9,
      price_per_vehicle: 450,
      price_per_mile_per_vehicle: 0.95,
      distance_miles: 474,
      dispatched_date: '2025-12-19',
      delivered_date: '2025-12-22',
      origin: {
        city: 'Carson City',
        state: 'NV',
        zip: '89701',
      },
      destination: {
        city: 'Long Beach',
        state: 'CA',
        zip: '90802',
      },
      vehicles: [
        {
          type: 'van',
          year: 2025,
          make: 'Chevrolet',
          model: 'Express',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: '4_door_pickup',
          year: 2026,
          make: 'Chevrolet',
          model: 'Colorado',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 800,
      price_per_mile: 1.48,
      price_per_vehicle: 400,
      price_per_mile_per_vehicle: 0.74,
      distance_miles: 539,
      dispatched_date: '2025-12-29',
      delivered_date: '2026-01-06',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2017,
          make: 'LEXUS',
          model: 'RX 350 BASE',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2025,
          make: 'KIA',
          model: 'SORENTO SX',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 800,
      price_per_mile: 1.48,
      price_per_vehicle: 400,
      price_per_mile_per_vehicle: 0.74,
      distance_miles: 539,
      dispatched_date: '2025-12-05',
      delivered_date: '2025-12-11',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2025,
          make: 'HYUNDAI',
          model: 'SONATA SEL',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2025,
          make: 'HYUNDAI',
          model: 'SONATA SEL',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 850,
      price_per_mile: 1.58,
      price_per_vehicle: 425,
      price_per_mile_per_vehicle: 0.79,
      distance_miles: 539,
      dispatched_date: '2025-11-25',
      delivered_date: '2025-12-04',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2021,
          make: 'TOYOTA',
          model: 'TUNDRA CREWMAX 1794',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2024,
          make: 'TOYOTA',
          model: 'Corolla LE',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 900,
      price_per_mile: 1.67,
      price_per_vehicle: 450,
      price_per_mile_per_vehicle: 0.83,
      distance_miles: 539,
      dispatched_date: '2025-11-28',
      delivered_date: '2025-12-04',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2024,
          make: 'FORD',
          model: 'BRONCO OUTER BANKS',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2013,
          make: 'TOYOTA',
          model: 'TACOMA DOUBLE CAB',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 1000,
      price_per_mile: 1.93,
      price_per_vehicle: 500,
      price_per_mile_per_vehicle: 0.97,
      distance_miles: 518,
      dispatched_date: '2026-02-16',
      delivered_date: '2026-02-18',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90249',
      },
      vehicles: [
        {
          type: '4_door_pickup',
          year: 2018,
          make: 'Ford',
          model: 'F-250 Super Duty',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: '4_door_pickup',
          year: 2017,
          make: 'Chevrolet',
          model: 'Silverado 1500',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 1750,
      price_per_mile: 3.51,
      price_per_vehicle: 583.33,
      price_per_mile_per_vehicle: 1.17,
      distance_miles: 498,
      dispatched_date: '2026-01-08',
      delivered_date: '2026-01-16',
      origin: {
        city: 'Truckee',
        state: 'CA',
        zip: '96161',
      },
      destination: {
        city: 'Gardena,',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2021,
          make: 'Toyota',
          model: 'Mirai',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'suv',
          year: 2025,
          make: 'Honda',
          model: 'CR-V',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'suv',
          year: 2021,
          make: 'Toyota',
          model: 'Highlander',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 450,
      price_per_mile: 0.87,
      price_per_vehicle: 450,
      price_per_mile_per_vehicle: 0.87,
      distance_miles: 520,
      dispatched_date: '2026-02-16',
      delivered_date: '2026-02-20',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Torrance',
        state: 'CA',
        zip: '90503',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2015,
          make: 'Toyota',
          model: 'Prius',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 500,
      price_per_mile: 1.1,
      price_per_vehicle: 500,
      price_per_mile_per_vehicle: 1.1,
      distance_miles: 454,
      dispatched_date: '2026-02-19',
      delivered_date: '2026-02-20',
      origin: {
        city: 'Fallon',
        state: 'NV',
        zip: '89406',
      },
      destination: {
        city: 'Norco',
        state: 'CA',
        zip: '92860',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2013,
          make: 'Dodge',
          model: 'Dart',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 490,
      price_per_mile: 0.96,
      price_per_vehicle: 490,
      price_per_mile_per_vehicle: 0.96,
      distance_miles: 512,
      dispatched_date: '2026-02-13',
      delivered_date: '2026-02-18',
      origin: {
        city: 'RENO',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'CARSON',
        state: 'CA',
        zip: '90810',
      },
      vehicles: [
        {
          type: 'suv',
          year: 2015,
          make: 'BMW',
          model: 'X3 XDRIVE3',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 1200,
      price_per_mile: 2.31,
      price_per_vehicle: 400,
      price_per_mile_per_vehicle: 0.77,
      distance_miles: 519,
      dispatched_date: '2026-01-29',
      delivered_date: '2026-02-03',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90248',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2025,
          make: 'HYUNDAI',
          model: 'KONA SEL',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2025,
          make: 'HYUNDAI',
          model: 'SONATA SEL',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'sedan',
          year: 2026,
          make: 'GMC',
          model: 'TERRAIN ELEVATION',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
  ],
  recent_postings: [
    {
      price: 450,
      price_per_mile: 0.93,
      price_per_vehicle: 450,
      price_per_mile_per_vehicle: 0.93,
      distance_miles: 485,
      posted_date: '2026-02-23',
      pickup_date: '2026-02-23',
      origin: {
        city: 'Carson City',
        state: 'NV',
        zip: '89701',
      },
      destination: {
        city: 'Harbor City',
        state: 'CA',
        zip: '90710',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2020,
          make: 'Nissan',
          model: 'Altima',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 625,
      price_per_mile: 1.27,
      price_per_vehicle: 312.5,
      price_per_mile_per_vehicle: 0.635,
      distance_miles: 494,
      posted_date: '2026-02-21',
      pickup_date: '2026-02-20',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89502',
      },
      destination: {
        city: 'Newport Beach',
        state: 'CA',
        zip: '92660',
      },
      vehicles: [
        {
          type: '4_door_pickup',
          year: 2025,
          make: 'Toyota',
          model: 'Tacoma',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'suv',
          year: 2025,
          make: 'Toyota',
          model: '4Runner',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 700,
      price_per_mile: 1.46,
      price_per_vehicle: 700,
      price_per_mile_per_vehicle: 1.46,
      distance_miles: 481,
      posted_date: '2026-02-21',
      pickup_date: '2026-02-21',
      origin: {
        city: 'Fallon',
        state: 'NV',
        zip: '89496',
      },
      destination: {
        city: 'Garden Grove',
        state: 'CA',
        zip: '92843',
      },
      vehicles: [
        {
          type: 'van',
          year: 0,
          make: '1997 Dodge Ram',
          model: 'Wagon',
          requires_enclosed_trailer: false,
          is_inoperable: true,
        },
      ],
    },
    {
      price: 600,
      price_per_mile: 1.16,
      price_per_vehicle: 600,
      price_per_mile_per_vehicle: 1.16,
      distance_miles: 517,
      posted_date: '2026-02-19',
      pickup_date: '2026-02-24',
      origin: {
        city: 'Sparks',
        state: 'NV',
        zip: '89434',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90249',
      },
      vehicles: [
        {
          type: '4_door_pickup',
          year: 2017,
          make: 'Ram',
          model: '1500',
          requires_enclosed_trailer: false,
          is_inoperable: true,
        },
      ],
    },
    {
      price: 320,
      price_per_mile: 0.69,
      price_per_vehicle: 320,
      price_per_mile_per_vehicle: 0.69,
      distance_miles: 463,
      posted_date: '2026-02-19',
      pickup_date: '2026-02-23',
      origin: {
        city: 'Sparks',
        state: 'NV',
        zip: '89434',
      },
      destination: {
        city: 'Ontario',
        state: 'CA',
        zip: '91764',
      },
      vehicles: [
        {
          type: 'suv',
          year: 2006,
          make: 'Jeep',
          model: 'Grand Cherokee',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 600,
      price_per_mile: 1.18,
      price_per_mile_per_vehicle: 1.18,
      price_per_vehicle: 600,
      distance_miles: 509,
      posted_date: '2026-02-17',
      pickup_date: '2026-02-18',
      origin: {
        city: 'Sparks',
        state: 'NV',
        zip: '89431',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90249',
      },
      vehicles: [
        {
          type: 'suv',
          year: 2023,
          make: 'Nissan',
          model: 'Kicks',
          requires_enclosed_trailer: false,
          is_inoperable: true,
        },
      ],
    },
    {
      price: 600,
      price_per_mile: 1.16,
      price_per_mile_per_vehicle: 1.16,
      price_per_vehicle: 600,
      distance_miles: 518,
      posted_date: '2026-02-17',
      pickup_date: '2026-02-18',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89506',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90249',
      },
      vehicles: [
        {
          type: 'suv',
          year: 2022,
          make: 'Chevrolet',
          model: 'Suburban',
          requires_enclosed_trailer: false,
          is_inoperable: true,
        },
      ],
    },
    {
      price: 400,
      price_per_mile: 0.83,
      price_per_mile_per_vehicle: 0.83,
      price_per_vehicle: 400,
      distance_miles: 484,
      posted_date: '2026-02-16',
      pickup_date: '2026-02-14',
      origin: {
        city: 'Reno',
        state: 'NV',
        zip: '89502',
      },
      destination: {
        city: 'Fullerton',
        state: 'CA',
        zip: '92831',
      },
      vehicles: [
        {
          type: 'sedan',
          year: 2024,
          make: 'Toyota',
          model: 'Prius',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
    {
      price: 1000,
      price_per_mile: 1.93,
      price_per_mile_per_vehicle: 0.965,
      price_per_vehicle: 500,
      distance_miles: 518,
      posted_date: '2026-02-16',
      pickup_date: '2026-02-24',
      origin: {
        city: 'Sparks',
        state: 'NV',
        zip: '89434',
      },
      destination: {
        city: 'Gardena',
        state: 'CA',
        zip: '90249',
      },
      vehicles: [
        {
          type: '4_door_pickup',
          year: 2016,
          make: 'GMC',
          model: 'Sierra 1500',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
        {
          type: 'suv',
          year: 2017,
          make: 'Jeep',
          model: 'Wrangler Unlimited',
          requires_enclosed_trailer: false,
          is_inoperable: false,
        },
      ],
    },
  ],
};
